import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import QueryCreateMain from '../../presentation/section/query-create-page/QueryCreateMain';
import { postExpress, getExpressParams, getExpress } from '../../../service/api';
import JSONtoChartData from '../json-to-chartdata/JSONtoChartData';
import { REPORT_RANGE } from '../../../config/CalendarRangeSet';
import LoadingOverlay from 'react-loading-overlay';
import { queryValidator } from '../function/QueryValidator';

const getDefaultDateRange = () => {
  const today = new Date();
  const aWeekAgoDate = new Date();
  aWeekAgoDate.setDate(today.getDate()-7);
  return [aWeekAgoDate, today];
}

const QueryCreate = (props) => {
  const [noiseFilters, setNoiseFilters] =useState([]); 
  // const noiseFilters = NoiseFilteringData;

  const [andString, setAndString] = useState('');
  const [orString, setOrString] = useState('');
  const [notString, setNotString] = useState('');
  const [booleanQuery, setBooleanQuery] = useState('');
  const [resultData, setResultData] = useState({
    buzzlist: null,
    volume: null
  });
  const [userLabelData, setUserLabelData] = useState([]);
  const [tempQuery, setTempQuery] = useState(null);
  const [saveTooltip, setSaveTooltip] = useState('');

  useEffect(()=> {
    console.log('')
  },[userLabelData])

  useEffect(()=> {
    getUserLabelData((res)=>setUserLabelData(res));

    getExpress('/query/noisefilter', (response) => {
      let pushFilter = [];

      response.data.forEach((item) => {
        pushFilter.push({
          category: item.category,
          id: `noise-filter-${item.filterID}`,
          booleanFilterString: item.booleanFilter,
          basicFilterString: item.basicFilter
        })
      })
      setNoiseFilters(pushFilter);
    });
  }, [])

  const getUserLabelData = (callback) => {
    getExpressParams('/query/label/userid/all', {
      email: props.currentUser
    }, (response) => {
      callback(response.data.BuzzLabel.info)
    });
  };

  const [dateRange, setDate] = useState(getDefaultDateRange());
  const [loaded, setLoaded] = useState(true);

  const handleRefresh = () => {
    if(!tempQuery){
    }
    else{
      setLoaded(false);
      setResultData({
        buzzlist: null,
        volume: null
      })
      getExpressParams("/search/query-content", {
        "query": tempQuery.query,
        "type": tempQuery.type,
        "dateRange": [dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]
      },
      (res)=>{
        setLoaded(true);
        let resData = res.data;
        resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
        setResultData(resData);
      });
    }
  }

  const handleDate = (selectedDateRange) => {
    setDate(selectedDateRange);
  }

  const querySave = (type, queryName, labelName, labelID) => {
    switch (type) {
      case "basicQuery": {
        handleBasicQuery(andString, orString, notString);
        setSaveTooltip('검색어가 저장되었습니다.')
        saveQuery('/query/query-label/userid',{
          "type": "BASIC",
          "query": {
            "and": andString.split(/\s*(?:,|$)\s*/).filter(item=>item!=""),
            "or": orString.split(/\s*(?:,|$)\s*/).filter(item=>item!=""),
            "not": notString.split(/\s*(?:,|$)\s*/).filter(item=>item!="")
          },
          "queryName": queryName,
          "labelName": labelName,
          "labelID": labelID,
          "email": props.currentUser
        })
        break;
      }
      case "booleanQuery": {
        if(queryValidator(booleanQuery)){
          setSaveTooltip('검색어가 저장되었습니다.')
          saveQuery('/query/query-label/userid',{
            "type": "BOOLEAN",
            "query": {
              "boolQuery": booleanQuery
            },
            "queryName": queryName,
            "labelName": labelName,
            "labelID": labelID,
            "email": props.currentUser
          })
        }
        else{
          setSaveTooltip('검색어를 확인해주세요.')
        }
        break;
      }
      default: {
        break;
      }
    }
    getUserLabelData((res)=>setUserLabelData(res));
  }

  const checkQueryResult = (path, query, result) => {

    switch (query.type) {
      case "BOOLEAN":{
          if (queryValidator(query.query.boolQuery)){
            setLoaded(false);
            setTempQuery(query);

            setResultData({
              buzzlist: null,
              volume: null
            })
            getExpressParams(path, query,
            (res)=>{
              setLoaded(true);
              console.log(res)
              let resData = res.data;
              resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
              console.log(resData)
              setResultData(resData);
            });

          }
          else {
          }
          break;
        }
      case "BASIC":{
          setLoaded(false);
          setTempQuery(query);

          setResultData({
            buzzlist: null,
            volume: null
          })
          getExpressParams(path, query,
          (res)=>{
            setLoaded(true);

            let resData = res.data;
            resData.volume = JSONtoChartData({data:res.data.volume, type:"report-line"})
            setResultData(resData);
          });
          break;
        }
      default:
        break;
    }

  }

  const saveQuery = (path, query) => {
    postExpress(path, query,
      (res)=>{
      })
  }

  const handleBasicQuery = (andQuery, orQuery, notQuery) => {
  }

  const handleBooleanQuery = (event) => {
    setBooleanQuery(event.target.value);
  }

  const handleNotString = (event) => {
    setNotString(event.target.value);
  }

  const handleOrString = (event) => {
    setOrString(event.target.value);
  }

  const handleAndString = (event) => {
    setAndString(event.target.value);
  }

  const addNoiseFilterString = (queryType, noiseFilterString) => {
    switch (queryType){
      case 'basicQuery': {
        setNotString(`${notString} ${noiseFilterString}`);
        break;
      }
      case 'booleanQuery': {
        setBooleanQuery(`(${booleanQuery}) & (${noiseFilterString})`);
        break;
      }
      default: {
        break;
      }
    }
  }

  return(
    <LoadingOverlay
      active={!loaded}
      spinner={true}
      text="Now Loading...">
      <QueryCreateMain noiseFilters={noiseFilters} addNoiseFilterString={addNoiseFilterString}
        andString={andString} handleAndString={handleAndString} orString={orString} handleOrString={handleOrString}
        notString={notString} handleNotString={handleNotString} checkQueryResult={checkQueryResult} resultData={resultData}
        querySave={querySave} dateRange={dateRange}
        booleanQuery={booleanQuery} handleBooleanQuery={handleBooleanQuery}
        handleRefresh={handleRefresh} handleDate={handleDate}
        userLabelData={userLabelData}
        minDate={REPORT_RANGE(props.currentRole)}
        saveTooltip={saveTooltip}
      />
    </LoadingOverlay>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole
});

export default connect(mapStateToProps) (QueryCreate);